import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import WarehouseCommonApi from '../../../API/warehouse/common-api';
import { SelectInput } from '../../Basic/Inputs';

export default function WarehouseAddressInput({ warehouseId = null, address = '', onChange = () => { }, style, ...props }) {
  const skladName = useSelector(store => store.ui.skladName.short_name)

  const [list, setList] = useState([]);
  const [value, setValue] = useState('');
  const [savedAddress, setSavedAddress] = useState(address);
  const [isOk, setIsOk] = useState(null);

  const user = useSelector((store) => store.user);


  const changeAddress = async (value) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId, field: 'address', value, skladName } })
      .then((r) => {
        if (r.warehouseProduct) {
          console.log("saved", value)
          onChange(r.warehouseProduct);
        }
      })
      .catch((err) => console.log(err));
  };

  const findAddress = (search) => {
    WarehouseCommonApi.findAddress({ data: { search, skladName } }).then((r) => {
      const names = r.addresses;
      setList(names);
      if (r.matchedAddress) {
        setIsOk(true);
      } else {
        setIsOk(false);
      }
    });
  };

  const clickAdd = async (v) => {
    WarehouseCommonApi.addAddress({ data: { address: v, skladName } }).then((r) => {
      if (r.address) {
        setValue(v);
        setSavedAddress(r.address);
        setIsOk(null);
      } else {
        setIsOk(false);
      }
    });
  };

  const onSelect = async (v) => {
    setValue(v);
    setSavedAddress(v);
    setIsOk(null);
  };

  const onBlur = async () => {
    //console.log("blur", value, savedAddress)
    if (isOk) {
      setSavedAddress(value);
      setIsOk(null);
    }
  };

  const deletePlace = async () => {
    setSavedAddress('');
    setIsOk(null);
  };

  useEffect(() => {
    setValue(address);

    // setSavedAddress(address); // стиреть 
  }, [address, warehouseId]);

  const onChangeInput = (v) => {
    setValue(v);
    findAddress(v);
  };

  useEffect(() => {

    //  console.log("savedAddress: ", savedAddress, "address:" , address, savedAddress !== address)
    if (savedAddress !== address) {
      changeAddress(savedAddress);
    }
  }, [savedAddress]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <SelectInput
      select={value}
      list={list}
      add={isOwner}
      addText={'Добавить'}
      {...props}
      isOk={isOk}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      onFocus={(v) => findAddress(v)}
      clickAdd={(v) => clickAdd(v)}
      deletePlace={(v) => deletePlace(v)}
    />
  );
}
